<template>
    <router-link :to="{ name: 'orderview', params: { orderId: order.id , targettype:order.targetType} }" class="order-item  fs2">
        <div class="clear pbm order-item__hd">
            <div class="left">
                <i class="iconfont">&#xe606;</i> {{ order.sn }}
            </div>
            <div :class="order.status" class="right c6">{{ orderStatusText[order.status] }}</div>
        </div>
        <div class="mtm">
            <div class="clear mtn order-item__info">
                <div class="left c6">购买《{{ order.title }}》</div>
            </div>
            <!-- <div class="clear mtn order-item__info">
                <div class="left c6">{{ paidtime }}</div>
            </div> -->
            <div class="clear mtn order-item__info">
                <div class="left c9">七天无理由退换货</div>
            </div>
            <div class="clear mtn order-item__price">
                <div class="left">合计：¥{{ order.amount }}</div>
            </div>
        </div>
    </router-link>
</template>
<script>
import moment from 'moment';
moment.locale('zh-cn');

export default {
    name: 'OrderItem',
    props: {
      order: {
        type: Object,
      }
    },
    data(){
      return {
        orderStatusText: {
          'created': '待付款',
          'paid': '付款成功',
          'refunding': '申请退款中',
          'refunded': '退款成功',
          'cancelled': '订单已取消'
        }
      }
    },
    computed: {
        paidtime: function () {
            return moment(this.order.paidTime*1000).format('YYYY-MM-DD HH:mm:ss')
        },
        // toView: function(){
        //     if(this.order.targetType=='clubGroupCourse'){
        //         //团课
        //         return 'orderview'
        //     }
        // }
    }
}
</script>
<style lang="less">
.order-item{
    display: block;
    color: #666;
    padding: .15rem;
    &__hd{
        border-bottom: .01rem #f6f6f6 solid;
        &>.created{
          color: #F4B53A;
        }
        &>.paid{
          color:#06bf04;
        }
        &>.refunding{
          color: red;
        }
        &>.cancelled{
            color: #999
        }

    }
    &__ft{
        border-top: .01rem #f6f6f6 solid;
    }
    &__info{
        &>div{
            // width: 30%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderItem.vue